import palette from "assets/theme/base/palette";
import React from "react";
import { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import FormLabel from "@mui/material/FormLabel";
import logo from "assets/images/maxu-gray.png";
import { call } from "services/axiosService/core";
import { useMaterialUIController } from "context";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import MaxuLogo from "assets/images/nav-logo.png";
import Loader from "pages/loader/Loader";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import ReactPlayer from "react-player";
import * as Sentry from "@sentry/browser";
import ContentPlayerDialog from "examples/Dialog/ContentPlayerDialog";
import ShareContentDialog from "examples/Dialog/ShareContentDialog";
import NoContent from "pages/NoContent";
import { useTranslation } from "react-i18next";

const ContentLibrary = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [controller] = useMaterialUIController();
  const { profile, persona } = controller;
  const [insight, setInsight] = useState(null);
  const matches = useMediaQuery("(max-width:420px)");
  const [inSightContentLinks, setInsightContentLinks] = useState(null);
  const [topContent, setTopContent] = useState([]);
  const [allContentLinks, setAllContentLinks] = useState([]);
  const [contentFilter, setContentFilter] = useState("allContentLinks");
  const [mediaFilter, setMediaFilter] = useState("all");
  const [searchFilter, setSearchFilter] = useState("");
  const [learnerName, setLearnerName] = useState("");
  const [learnersDetails, setLearnersDetails] = useState([]);
  const [allAssessments, setAllAssessments] = useState([]);
  const [val, setVal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [noContent, setNoContent] = useState(false);
  const [learnerId, setLearnerId] = useState(location.state ? location.state.learnerId : null);
  const [assessmentId, setAssessmentId] = useState(
    location.state ? location.state.assessmentId : null
  );
  const [content, setContent] = useState({});
  const [playContent, setPlayContent] = useState(false);
  const [userMetricsData, setUserMetricsData] = useState(null);
  const [likedContent, setLikedContent] = useState([]);
  const [dislikedContent, setDislikedContent] = useState([]);
  const [savedContent, setSavedContent] = useState([]);
  const [viewedContent, setViewedContent] = useState([]);
  const [recommendedContent, setRecommendedContent] = useState([]);
  const [shareContent, setShareContent] = useState(false);
  const [shareContentTitle, setShareContentTitle] = useState("");
  const [learnerMetricsData, setLearnerMetricData] = useState(null);
  const [assessmentType, setAssessmentType] = useState("NEO");
  useEffect(() => {
    loadAllLearnersAssessments();
  }, [profile]);

  useEffect(() => {
    loadUserContents();
  }, [assessmentId]);

  useEffect(() => {
    loadUserContentMetrics();
  }, [profile]);

  useEffect(() => {
    loadLearnerContentMetrics();
  }, [learnerId]);

  const loadLearnerContentMetrics = () => {
    if (learnerId != profile.id) {
      call(`users/${learnerId}/contentmetrics`, "GET", {})
        .then((res) => {
          if (res.status == 200) {
            let data = res.data;
            setLearnerMetricData(data);
          }
        })
        .catch((err) => {
          Sentry.captureException(err);
          console.log(err);
        });
    }
  };

  const loadUserContentMetrics = () => {
    if (profile.id) {
      call(`users/${profile.id}/contentmetrics`, "GET", {})
        .then((res) => {
          if (res.status == 200) {
            let data = res.data;
            setUserMetricsData(data);
            setLikedContent([...data.likedcontent]);
            setDislikedContent([...data.dislikedcontent]);
            setViewedContent([...data.viewedcontent]);
            setSavedContent([...data.savedcontent]);
            setRecommendedContent([...data.recommendedcontent]);
          }
        })
        .catch((err) => {
          Sentry.captureException(err);
          console.log(err);
        });
    }
  };

  const loadAllLearnersAssessments = () => {
    if (profile.id) {
      call(`users/${profile.id}/content`, "GET", {})
        .then((res) => {
          if (res.status == 200) {
            let data = res.data;
            console.log("data", data)
            if (data.length == 0) {
              setNoContent(true);
              setLoading(false);
            } else if (data.length == 1) {
              setLearnerId(data[0]["learnerId"]);
              if (data[0]["assessments"].length == 0) {
                setLoading(false);
                setLearnersDetails(data);
                setNoContent(true);
              } else {
                setLoading(false);
                setNoContent(false);
                setLearnersDetails(data);
                setAllAssessments(data[0]["assessments"]);
                assessmentId == null
                  ? setVal(data[0]["assessments"][0])
                  : setVal(
                      data[0]["assessments"].filter((row) => row.assessment_id == assessmentId)[0]
                    );
                assessmentId == null && setAssessmentId(data[0]["assessments"][0]["assessment_id"]);
              }
            } else {
              if (assessmentId == null) {
                setLoading(false);
                setLearnerId(data[0]["learnerId"]);
                if (data[0]["assessments"].length == 0) {
                  setAllAssessments(data[0]["assessments"]);
                  setLearnersDetails(data);
                  setNoContent(true);
                } else {
                  setAllAssessments(data[0]["assessments"]);
                  setAssessmentId(data[0]["assessments"][0]["assessment_id"]);
                  setVal(data[0]["assessments"][0]);
                  setLearnersDetails(data);
                }
              } else {
                const le = data.filter((row) => row.learnerId == learnerId);
                setAllAssessments(le[0]["assessments"]);
                const as = le[0]["assessments"].filter((row) => row.assessment_id == assessmentId);
                setVal(as[0]);
                setLearnersDetails(data);
              }
            }
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          Sentry.captureException(err);
          console.log("error is", err);
        });
    }
  };

  const loadUserContents = () => {
    if (learnerId != null && assessmentId != null) {
      setLoading(true);
      call(`users/${learnerId}/assessments/${assessmentId}/contents`, "GET", {})
        .then((res) => {
          if (res.status == 200) {
            const resData = res.data;
            const type = resData.assessment_type;
            setAssessmentType(type);
            setTopContent(
              resData.insights.top_content.sort((a, b) =>
                parseFloat(a.weight) < parseFloat(b.weight) ? 1 : -1
              )
            );
            let allLinks = [];
            if (type == "NEO") {
              setInsight(resData.insights.insight_details);
              allLinks = [
                ...resData.insights.insight_details.Agreeableness.content_links,
                ...resData.insights.insight_details.Conscientiousness.content_links,
                ...resData.insights.insight_details.Openness.content_links,
                ...resData.insights.insight_details.Extraversion.content_links,
                ...resData.insights.insight_details.Temperament.content_links,
              ];
            } else {
              setInsight(resData.insights.content);
              allLinks = [...resData.insights.content];
            }
            const ids = allLinks.map(({ title }) => title);
            const filteredLinks = allLinks.filter(
              ({ title }, index) => !ids.includes(title, index + 1)
            );
            filteredLinks.sort((a, b) => (parseFloat(a.weight) < parseFloat(b.weight) ? 1 : -1));
            setAllContentLinks(filteredLinks);
            setInsightContentLinks(filteredLinks);
            // setLearnerName(resData.insights.summary.split(" ")[0]);
            setLoading(false);
            setNoContent(false);
          }else {
            setNoContent(true);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          Sentry.captureException(err);
          setNoContent(true);
          setLoading(false);
        });
    }
  };

  const defaultLearner = () => {
    if (learnerId == null) {
      return learnersDetails[0];
    } else {
      const le = learnersDetails.filter((row) => row.learnerId == learnerId);
      setLearnerName(le[0].learnerName.split(" ")[0]);
      return le[0];
    }
  };

  const learnerChangeHandler = (value) => {
    setLearnerName(value.learnerName.split(" ")[0]);
    setLearnerId(value.learnerId);
    setInsight(null);
    setAllAssessments([]);

    let user = learnersDetails.filter((row) => row.learnerId == value.learnerId);
    let assess = user[0]["assessments"];
    if (assess.length == 0) {
      setAllAssessments(assess);
      setAssessmentId(null);
      setVal(null);
      setNoContent(true);
    } else {
      setVal(assess[0]);
      setAssessmentId(assess[0]["assessment_id"]);
      setAllAssessments(assess);
    }
  };

  const likeHandler = (title) => {
    let eventkey = { event: "likecontent", value: title };
    var currentlikedContent = [...likedContent];
    var currentdislikedContent = [...dislikedContent];
    currentlikedContent.push(title);
    // if content in disliked array remove it from there
    if (currentdislikedContent.includes(title)) {
      const index = currentdislikedContent.indexOf(title);
      currentdislikedContent.splice(index, 1);
      eventkey = { event: "likecontent-removedislike", value: title };
    }
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;

    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setLikedContent([...currentlikedContent]);
          setDislikedContent([...currentdislikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const dislikeHandler = (title) => {
    let eventkey = { event: "dislikecontent", value: title };
    var currentlikedContent = [...likedContent];
    var currentdislikedContent = [...dislikedContent];
    currentdislikedContent.push(title);
    // if content in liked array remove it from there
    if (currentlikedContent.includes(title)) {
      const index = currentlikedContent.indexOf(title);
      currentlikedContent.splice(index, 1);
      eventkey = { event: "dislikecontent-removelike", value: title };
    }
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setDislikedContent([...currentdislikedContent]);
          setLikedContent([...currentlikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const removeLikeHandler = (title) => {
    let eventkey = { event: "removelikecontent", value: title };

    var currentlikedContent = [...likedContent];
    const index = currentlikedContent.indexOf(title);
    currentlikedContent.splice(index, 1);
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setLikedContent([...currentlikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const removeDislikeHandler = (title) => {
    let eventkey = { event: "removedislikecontent", value: title };
    var currentdislikedContent = [...dislikedContent];
    const index = currentdislikedContent.indexOf(title);
    currentdislikedContent.splice(index, 1);
    let metricData = userMetricsData;
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setDislikedContent([...currentdislikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const saveHandler = (title) => {
    let eventkey = { event: "savedcontent", value: title };
    let currentSavedContent = [...savedContent];
    let metricData = userMetricsData;
    if (currentSavedContent.includes(title)) {
      const index = currentSavedContent.indexOf(title);
      currentSavedContent.splice(index, 1);
      eventkey = { event: "removeSaved", value: title };
    } else {
      currentSavedContent.push(title);
    }
    metricData["eventkey"] = eventkey;
    metricData["savedcontent"] = [...currentSavedContent];
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setSavedContent([...currentSavedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const shareHandler = (title) => {
    setShareContentTitle(title);
    setShareContent(true);
  };

  const getContentLinkHandler = (item) => {
    call(`content/${item.title}`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          setPlayContent(true);
          setContent(res.data);
        }
      })
      .catch((err) => {
        console.log("error is", err);
        Sentry.captureException(err);
      });
  };

  const closeContentPlayer = () => {
    setPlayContent(false);
  };

  const closeShareContentHandler = () => {
    setShareContent(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title={t("pageTitles.contentLibrary")} />
      <MDBox mt={1} />
      <UserSelection
        learnersDetails={learnersDetails}
        defaultLearner={defaultLearner}
        learnerChangeHandler={learnerChangeHandler}
        allAssessments={allAssessments}
        val={val}
        setVal={setVal}
        setAssessmentId={setAssessmentId}
        t={t}
      />
      {insight && (
        <Grid container spacing={1} mt={1}>
          <TopContent
            topContent={topContent}
            profile={profile}
            getContentLinkHandler={getContentLinkHandler}
            likedContent={likedContent}
            dislikedContent={dislikedContent}
            likeHandler={likeHandler}
            dislikeHandler={dislikeHandler}
            removeLikeHandler={removeLikeHandler}
            removeDislikeHandler={removeDislikeHandler}
            shareHandler={shareHandler}
            saveHandler={saveHandler}
            savedContent={savedContent}
            viewedContent={viewedContent}
            learnerId={learnerId}
            t={t}
          />
          <Grid item xs={12} md={12} flex={1}>
            {/* ── Filter Card ── */}
            <Card sx={{ mb: 2 }}>
              <MDBox p={2.5}>
                {/* Header row */}
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <Icon sx={{ color: palette.brand[500] }}>filter_alt</Icon>
                    <MDTypography variant="h6" fontWeight="medium">
                      {t("contentLibrary.contentTitle", { name: learnerName })}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    onClick={() => {
                      setInsightContentLinks(allContentLinks);
                      setContentFilter("allContentLinks");
                      setMediaFilter("all");
                      setSearchFilter("");
                    }}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.5,
                      px: 1.5,
                      py: 0.6,
                      borderRadius: "8px",
                      bgcolor: palette.neutral[100],
                      border: `1px solid ${palette.neutral[300]}`,
                      cursor: "pointer",
                      transition: "all 180ms ease",
                      "&:hover": {
                        bgcolor: palette.neutral[200],
                        borderColor: palette.neutral[400],
                      },
                    }}
                  >
                    <Icon sx={{ fontSize: "14px !important", color: palette.neutral[600] }}>close</Icon>
                    <MDTypography variant="caption" fontWeight="bold" sx={{ color: palette.neutral[700] }}>
                      {t("contentLibrary.clearAll")}
                    </MDTypography>
                  </MDBox>
                </MDBox>

                {/* Search bar */}
                <MDBox mb={2}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder={t("contentLibrary.searchPlaceholder")}
                    value={searchFilter}
                    onChange={(e) => setSearchFilter(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon sx={{ fontSize: "18px !important", color: palette.neutral[500] }}>search</Icon>
                        </InputAdornment>
                      ),
                      endAdornment: searchFilter ? (
                        <InputAdornment position="end">
                          <Icon
                            onClick={() => setSearchFilter("")}
                            sx={{ fontSize: "16px !important", color: palette.neutral[400], cursor: "pointer", "&:hover": { color: palette.neutral[700] } }}
                          >close</Icon>
                        </InputAdornment>
                      ) : null,
                      sx: { borderRadius: "10px" },
                    }}
                  />
                </MDBox>

                {/* Personality pills (NEO only) */}
                {assessmentType == "NEO" && (
                  <MDBox display="flex" gap={1} mb={2.5}>
                    {[
                      { key: "allContentLinks", label: t("contentLibrary.showAll"), sub: t("contentLibrary.filterSubtitles.showEverything"), icon: "grid_view", color: "#10b0d5", bg: "#e8f8fd", fn: () => allContentLinks },
                      { key: "Agreeableness", label: t("contentLibrary.agreeableness"), sub: t("contentLibrary.filterSubtitles.agreeableness"), icon: "handshake", color: "#4caf50", bg: "#e8f5e9", fn: () => insight.Agreeableness.content_links.sort((a,b) => parseFloat(a.weight) < parseFloat(b.weight) ? 1 : -1) },
                      { key: "Conscientiousness", label: t("contentLibrary.conscientiousness"), sub: t("contentLibrary.filterSubtitles.conscientiousness"), icon: "gps_fixed", color: "#2196f3", bg: "#e3f2fd", fn: () => insight.Conscientiousness.content_links.sort((a,b) => parseFloat(a.weight) < parseFloat(b.weight) ? 1 : -1) },
                      { key: "Openness", label: t("contentLibrary.openness"), sub: t("contentLibrary.filterSubtitles.openness"), icon: "lightbulb", color: "#9c27b0", bg: "#f3e5f5", fn: () => insight.Openness.content_links.sort((a,b) => parseFloat(a.weight) < parseFloat(b.weight) ? 1 : -1) },
                      { key: "Extraversion", label: t("contentLibrary.extraversion"), sub: t("contentLibrary.filterSubtitles.extraversion"), icon: "emoji_people", color: "#f48326", bg: "#fff3e6", fn: () => insight.Extraversion.content_links.sort((a,b) => parseFloat(a.weight) < parseFloat(b.weight) ? 1 : -1) },
                      { key: "Temperament", label: t("contentLibrary.temperament"), sub: t("contentLibrary.filterSubtitles.temperament"), icon: "favorite", color: "#e91e63", bg: "#fce4ec", fn: () => insight.Temperament.content_links.sort((a,b) => parseFloat(a.weight) < parseFloat(b.weight) ? 1 : -1) },
                    ].map(({ key, label, sub, icon, color, bg, fn }) => {
                      const active = contentFilter === key;
                      return (
                        <MDBox
                          key={key}
                          onClick={() => { setInsightContentLinks(fn()); setContentFilter(key); }}
                          sx={{
                            flex: 1,
                            display: "flex", alignItems: "center", gap: 1,
                            px: 1.5, py: 1,
                            borderRadius: "12px",
                            border: `1.5px solid ${active ? color : palette.neutral[300]}`,
                            bgcolor: active ? bg : "#fff",
                            cursor: "pointer",
                            transition: "all 180ms ease",
                            "&:hover": { borderColor: color, bgcolor: bg },
                          }}
                        >
                          <MDBox sx={{ bgcolor: bg, borderRadius: "8px", width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <Icon sx={{ color, fontSize: "16px !important" }}>{icon}</Icon>
                          </MDBox>
                          <MDBox>
                            <MDTypography variant="caption" fontWeight="bold" sx={{ color: active ? palette.brand[600] : "text.primary", display: "block", lineHeight: 1.2 }}>
                              {label}
                            </MDTypography>
                            <MDTypography variant="caption" sx={{ color: "text.secondary", fontSize: "0.65rem" }}>
                              {sub}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      );
                    })}
                  </MDBox>
                )}

                {/* Media type filter row */}
                <MDBox display="flex" gap={1} alignItems="center">
                  {["all", "Video", "Article", "Worksheet", "Infographic"].map((type) => {
                    const active = mediaFilter === type;
                    const icons = { all: "apps", Video: "play_circle", Article: "article", Worksheet: "note", Infographic: "leaderboard" };
                    return (
                      <MDBox
                        key={type}
                        onClick={() => setMediaFilter(type)}
                        sx={{
                          flex: 1,
                          display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5,
                          py: 0.8,
                          borderRadius: "10px",
                          border: `1.5px solid ${active ? palette.brand[500] : palette.neutral[300]}`,
                          bgcolor: active ? palette.brand[500] : "#fff",
                          cursor: "pointer",
                          transition: "all 180ms ease",
                          "&:hover": { borderColor: palette.brand[400], bgcolor: active ? palette.brand[500] : palette.brand[50] },
                        }}
                      >
                        <Icon sx={{ color: active ? "#fff" : palette.neutral[600], fontSize: "16px !important" }}>{icons[type]}</Icon>
                        <MDTypography variant="caption" fontWeight="medium" sx={{ color: active ? "#fff" : "text.primary" }}>
                          {t(`contentLibrary.mediaTypes.${type}`)}
                        </MDTypography>
                      </MDBox>
                    );
                  })}
                </MDBox>
              </MDBox>
            </Card>

            {/* ── Content Card ── */}
            <Card style={{ height: "100%" }}>
              <MDBox py={2} px={3} style={{ height: "100%" }}>
                <UserContent
                  inSightContentLinks={inSightContentLinks}
                  mediaFilter={mediaFilter}
                  searchFilter={searchFilter}
                  profile={profile}
                  getContentLinkHandler={getContentLinkHandler}
                  likedContent={likedContent}
                  dislikedContent={dislikedContent}
                  likeHandler={likeHandler}
                  dislikeHandler={dislikeHandler}
                  removeLikeHandler={removeLikeHandler}
                  removeDislikeHandler={removeDislikeHandler}
                  shareHandler={shareHandler}
                  saveHandler={saveHandler}
                  savedContent={savedContent}
                  viewedContent={viewedContent}
                  learnerId={learnerId}
                  t={t}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      )}

      {noContent && (
        <NoContent
          title={t("contentLibrary.noContentTitle")}
          subtitle={t("contentLibrary.noContentMessage")}
          icon="search"
          iconColor="#2196f3"
        />
      )}

      {loading && (
        <Dialog open={loading} fullScreen>
          <DialogContent>
            <Loader loaderText={t("loaderText.loadingContent")} />
          </DialogContent>
        </Dialog>
      )}

      {playContent && (
        <ContentPlayerDialog
          playContent={playContent}
          closeContentPlayer={closeContentPlayer}
          content={content}
          userMetricsData={userMetricsData}
          setViewedContent={setViewedContent}
          setUserMetricData={setUserMetricsData}
          userId={profile.id}
          t={t}
        />
      )}

      {shareContent && (
        <ShareContentDialog
          shareContent={shareContent}
          setShareContent={setShareContent}
          closeShareContentHandler={closeShareContentHandler}
          shareContentTitle={shareContentTitle}
          learnerMetricsData={learnerMetricsData}
          setLearnerMetricData={setLearnerMetricData}
          learnerId={learnerId}
          t={t}
        />
      )}
    </DashboardLayout>
  );
};

export default ContentLibrary;

const formatAssessmentDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", { month: "short", year: "numeric" });
};

const calculateAge = (dob) => {
  if (!dob) return null;
  const today = new Date();
  const birth = new Date(dob);
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age;
};

const UserSelection = ({
  learnersDetails,
  defaultLearner,
  learnerChangeHandler,
  allAssessments,
  val,
  setVal,
  setAssessmentId,
  t
}) => {
  const [selectedLearner, setSelectedLearner] = useState(null);

  useEffect(() => {
    if (!selectedLearner && learnersDetails.length > 0) {
      setSelectedLearner(defaultLearner());
    }
  }, [learnersDetails]);

  const handleLearnerChange = (newValue) => {
    setSelectedLearner(newValue);
    learnerChangeHandler(newValue);
  };

  return (
    <>
      {learnersDetails.length > 0 && (
        <Card sx={{ borderRadius: "16px" }}>
          <MDBox p={2.5}>
            <Grid container spacing={2} alignItems="flex-start">

              {/* ── Learner ── */}
              <Grid item xs={12} md={6}>
                <MDBox display="flex" alignItems="flex-start" gap={1.5}>
                  <MDBox
                    sx={{
                      bgcolor: palette.brand[50],
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      mt: 0.5,
                    }}
                  >
                    <Icon sx={{ color: palette.brand[500], fontSize: "20px !important" }}>person</Icon>
                  </MDBox>
                  <MDBox flex={1}>
                    <MDTypography variant="caption" sx={{ color: palette.brand[500], fontWeight: 600, letterSpacing: "0.05em", display: "block", mb: 0.5 }}>
                      {t("contentLibrary.selectLearner")}
                    </MDTypography>
                    <Autocomplete
                      disableClearable
                      defaultValue={defaultLearner()}
                      options={learnersDetails}
                      onChange={(_, newValue) => handleLearnerChange(newValue)}
                      getOptionLabel={(option) => option.learnerName || ""}
                      renderOption={(props, option) => {
                        const age = calculateAge(option.dob || option.date_of_birth);
                        const assessmentCount = option.assessments?.length || 0;
                        return (
                          <li {...props}>
                            <MDBox>
                              <MDTypography variant="body2" fontWeight="medium">{option.learnerName}</MDTypography>
                              <MDTypography variant="caption" sx={{ color: "text.secondary" }}>
                                {age ? t("contentLibrary.age", { age }) : ""}
                                {age && assessmentCount ? " · " : ""}
                                {assessmentCount ? t("contentLibrary.assessmentCount", { count: assessmentCount }) : ""}
                              </MDTypography>
                            </MDBox>
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" size="small" placeholder={t("contentLibrary.selectLearner")} />
                      )}
                      fullWidth
                    />
                    {selectedLearner && (
                      <MDTypography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 0.5 }}>
                        {(() => {
                          const age = calculateAge(selectedLearner.dob || selectedLearner.date_of_birth);
                          const count = selectedLearner.assessments?.length || 0;
                          return [
                            age ? t("contentLibrary.age", { age }) : null,
                            count ? t("contentLibrary.assessmentCount", { count }) : null,
                          ].filter(Boolean).join(" · ");
                        })()}
                      </MDTypography>
                    )}
                  </MDBox>
                </MDBox>
              </Grid>

              {/* ── Assessment ── */}
              <Grid item xs={12} md={6}>
                {allAssessments.length > 0 && (
                  <MDBox display="flex" alignItems="flex-start" gap={1.5}>
                    <MDBox
                      sx={{
                        bgcolor: palette.brand[50],
                        borderRadius: "50%",
                        width: 40,
                        height: 40,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        mt: 0.5,
                      }}
                    >
                      <Icon sx={{ color: palette.brand[500], fontSize: "20px !important" }}>assignment</Icon>
                    </MDBox>
                    <MDBox flex={1}>
                      <MDTypography variant="caption" sx={{ color: palette.brand[500], fontWeight: 600, letterSpacing: "0.05em", display: "block", mb: 0.5 }}>
                        {t("contentLibrary.selectAssessment")}
                      </MDTypography>
                      <Autocomplete
                        value={val}
                        disableClearable
                        options={allAssessments}
                        onChange={(_, newValue) => {
                          setVal(newValue);
                          setAssessmentId(newValue["assessment_id"]);
                        }}
                        getOptionLabel={(option) => option.assessment_name || ""}
                        renderOption={(props, option) => (
                          <li {...props}>
                            <MDBox>
                              <MDTypography variant="body2" fontWeight="medium">{option.assessment_name}</MDTypography>
                              <MDTypography variant="caption" sx={{ color: "text.secondary" }}>
                                {formatAssessmentDate(option.completion_date)}
                              </MDTypography>
                            </MDBox>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} variant="outlined" size="small" placeholder={t("contentLibrary.selectAssessment")} />
                        )}
                        fullWidth
                      />
                      {val && (
                        <MDTypography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 0.5 }}>
                          {formatAssessmentDate(val.completion_date)}
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                )}
              </Grid>

            </Grid>

            {/* ── Chips ── */}
            {(selectedLearner || val) && (
              <MDBox display="flex" gap={1} mt={2} flexWrap="wrap">
                {selectedLearner && (
                  <MDBox
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.5,
                      bgcolor: palette.brand[50],
                      border: `1px solid ${palette.brand[100]}`,
                      borderRadius: "20px",
                      px: 1.5,
                      py: 0.4,
                    }}
                  >
                    <Icon sx={{ fontSize: "14px !important", color: palette.brand[500] }}>person</Icon>
                    <MDTypography variant="caption" fontWeight="medium" sx={{ color: palette.brand[700] }}>
                      {selectedLearner.learnerName}
                    </MDTypography>
                  </MDBox>
                )}
                {val && (
                  <MDBox
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.5,
                      bgcolor: palette.brand[50],
                      border: `1px solid ${palette.brand[100]}`,
                      borderRadius: "20px",
                      px: 1.5,
                      py: 0.4,
                    }}
                  >
                    <Icon sx={{ fontSize: "14px !important", color: palette.brand[500] }}>assignment</Icon>
                    <MDTypography variant="caption" fontWeight="medium" sx={{ color: palette.brand[700] }}>
                      {val.assessment_name}
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
            )}
          </MDBox>
        </Card>
      )}
    </>
  );
};

const TopContent = ({
  topContent,
  profile,
  getContentLinkHandler,
  likedContent,
  dislikedContent,
  likeHandler,
  dislikeHandler,
  removeLikeHandler,
  removeDislikeHandler,
  shareHandler,
  saveHandler,
  savedContent,
  viewedContent,
  learnerId,
  t
}) => {
  return (
    <>
      {topContent && (
        <Grid item xs={12} md={12} flex={1}>
          <Card style={{ height: "100%" }}>
            <MDBox
              style={{ height: "100%" }}
              bgColor="white"
              variant="gradient"
              borderRadius="xl"
              sx={{ background: ({ palette: { background } }) => false && background.card }}
            >
              <MDBox py={2} pr={2} pl={4} style={{ height: "100%" }}>
                <MDBox pt={2} px={2} lineHeight={1.25}>
                  <MDTypography variant="h4" fontWeight="medium">
                   {t("contentLibrary.topContentTitle")}
                  </MDTypography>
                </MDBox>
                <MDBox p={2}>
                  <Grid container spacing={3}>
                    {topContent &&
                      topContent.map((item, index) => {
                        let icon = "movie";
                        let content_type = item.content_type.toLowerCase();
                        if (content_type == "video") {
                          icon = "movie";
                        } else if (content_type == "infographic") {
                          icon = "leaderboard";
                        } else if (content_type == "article") {
                          icon = "article";
                        } else if (content_type == "worksheet") {
                          icon = "note";
                        }
                        return (
                          <Grid item xs={12} md={4}>
                            <DefaultProjectCard
                              item={item}
                              icon={icon}
                              type={item.content_type}
                              title={item.title}
                              shareable={learnerId != profile.id}
                              content_url={item.content_url}
                              image={item.thumbnail_url || MaxuLogo}
                              getContentLinkHandler={getContentLinkHandler}
                              liked={likedContent.includes(item.title)}
                              disliked={dislikedContent.includes(item.title)}
                              saved={savedContent.includes(item.title)}
                              viewed={viewedContent.includes(item.title)}
                              likeHandler={likeHandler}
                              dislikeHandler={dislikeHandler}
                              removeLikeHandler={removeLikeHandler}
                              removeDislikeHandler={removeDislikeHandler}
                              saveHandler={saveHandler}
                              shareHandler={shareHandler}
                              action={{
                                type: "external",
                                route: item.content_url,
                                color: "info",
                                label: t("buttonTitles.view"),
                              }}
                            />
                          </Grid>
                        );
                      })}
                  </Grid>
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>
      )}
    </>
  );
};

const UserContent = ({
  inSightContentLinks,
  mediaFilter,
  searchFilter,
  profile,
  getContentLinkHandler,
  likedContent,
  dislikedContent,
  likeHandler,
  dislikeHandler,
  removeLikeHandler,
  removeDislikeHandler,
  shareHandler,
  saveHandler,
  savedContent,
  viewedContent,
  learnerId,
  t
}) => {
  const filteredLinks = inSightContentLinks
    ? inSightContentLinks.filter((item) => {
        const matchesMedia = mediaFilter === "all" || item.content_type?.toLowerCase() === mediaFilter.toLowerCase();
        const matchesSearch = !searchFilter || item.title?.toLowerCase().includes(searchFilter.toLowerCase());
        return matchesMedia && matchesSearch;
      })
    : [];

  return (
    <>
      {inSightContentLinks && (
        <Grid container spacing={3} mt={0}>
          <Grid item xs={12} md={12} flex={1}>
            <MDBox>
              <MDBox py={2}>
                  <Grid container spacing={3}>
                    {filteredLinks.map((item, index) => {
                        let icon = "movie";
                        let content_type = item.content_type.toLowerCase();
                        if (content_type == "video") {
                          icon = "movie";
                        } else if (content_type == "infographic") {
                          icon = "leaderboard";
                        } else if (content_type == "article") {
                          icon = "article";
                        } else if (content_type == "worksheet") {
                          icon = "note";
                        }
                        return (
                          <Grid item xs={12} md={4}>
                            <DefaultProjectCard
                              item={item}
                              icon={icon}
                              type={item.content_type}
                              title={item.title}
                              shareable={learnerId != profile.id}
                              content_url={item.content_url}
                              image={item.thumbnail_url || MaxuLogo}
                              getContentLinkHandler={getContentLinkHandler}
                              liked={likedContent.includes(item.title)}
                              disliked={dislikedContent.includes(item.title)}
                              saved={savedContent.includes(item.title)}
                              viewed={viewedContent.includes(item.title)}
                              likeHandler={likeHandler}
                              dislikeHandler={dislikeHandler}
                              removeLikeHandler={removeLikeHandler}
                              removeDislikeHandler={removeDislikeHandler}
                              saveHandler={saveHandler}
                              shareHandler={shareHandler}
                              action={{
                                type: "external",
                                route: item.content_url,
                                color: "info",
                                label: t("buttonTitles.view"),
                              }}
                            />
                          </Grid>
                        );
                      })}
                  </Grid>
              </MDBox>
            </MDBox>
          </Grid>
        </Grid>
      )}
    </>
  );
};
